import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import Selectsearch from "react-select";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
	FormGroup,
	Label,	
} from 'reactstrap';

import {
   
   deleteOCScoring,
   studentOCScoring,
   fetchOCScoring,
   allStudents,
} from 'Actions';
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import EditItem from './component/editform';

class captoreport extends Component {
   
   constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            listdiv:false,
            adddiv:false,
            editdiv:false,
            seldate:'', 
            student:'',
            club:'',
            sepmore:1,
            formValues: [{ holepar : "", fwhit : "", distance : "", girhit : "", puttlength:"", noputt : "", penalties : "", score : "", process : "", penradio:"", proradio:"", disfwhit:""}],
         };  
         
         this.onBackSection = this.onBackSection.bind(this);
         this.deleteForm = this.deleteForm.bind(this);
   } 

   UNSAFE_componentWillMount() {
      this.props.allStudents();
	}

   onAddSession() {
		this.setState({
         viewdiv:false,
         listdiv:false,
         editdiv:false,
         adddiv:true,
      });
   } 
      
   onBackSection() {
		this.setState({ 
         adddiv:false,
         editdiv:false,
         viewdiv:true,
         listdiv:true,
       });
	}
   
   selstudent = (evt) =>{
      var stdid=evt.value;
      this.setState({ student:stdid });
      var start='';
      var end='';
      this.props.studentOCScoring(stdid, start, end).then((data) => {   
         
         this.setState({ 
             listdiv:true,               
             adddiv:false,
             editdiv:false,
         });

     });
   }


   editAssessment(assmval){
        
      var id=assmval.gne_userID;
      var date=assmval.gne_date;
        
        this.props.fetchOCScoring(id, date).then((data) => {   
            var resdata=data.data;
            var troptobj=[]; 
            {resdata.map((teamval) => (   

               troptobj.push({
                  holepar:teamval.gne_holepar,
                  fwhit: teamval.gne_holepar!=3?teamval.gne_fwhit:'',
                  distance : teamval.gne_distance,
                  girhit: teamval.gne_girhit,
                  puttlength:teamval.gne_lengthputt,
                  noputt: teamval.gne_noputt,
                  penalties:teamval.gne_penalties,
                  score:teamval.gne_score,
                  process:teamval.gne_process,
                  penradio:teamval.gne_penalties==0 ? 0 : 1, 
                  proradio:teamval.gne_process==0 ? 0 : 1,
                  disfwhit:teamval.gne_holepar==3? 1 : 0,
               })
            ))} 
            
            this.setState({ 
               seldate:resdata[0].gne_date, 
               student:resdata[0].gne_userID,
               club:resdata[0].gne_courseID,
               formValues:troptobj,
               sepmore:resdata.length
            });

            this.setState({ 
                viewdiv:false,  
                listdiv:false,              
                adddiv:false,
                editdiv:true,
            });

        });
    }

    deleteForm(assmval){
      this.id = assmval.gne_userID;
      this.date = assmval.gne_date;
      this.confirmationDialog.current.openDialog();
    }

   deleteDataPermanent(popupResponse){
      
         if (popupResponse) {
            this.props.deleteOCScoring(this.id, this.date);
            this.data = ""
         }
   }

   

    render() {
      const { match, studentlists, ocscoringlist, loading } = this.props;
      const allstudent=studentlists.map((stdval) => {  
         return {
            label: stdval.student,  
            value: stdval.uudID
         }
      });
      const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
      };

      const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "action", label: "EDIT" },
            { name: "action1", label: "DELETE" },
          
      ];
        const tabledata=ocscoringlist.map((assmntval,idx) => {     
               const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;     
               const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
                
                return {
                  no:idx+1,
                  name: assmntval.student,
                  cdate: assmntval.cdate,
                  action: ebtn,
                  action1:dbtn,
                
                }
        }); 

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>On Course Scoring | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.oncscoring" />} match={match} />
               {this.state.viewdiv && 
                  <div className="col-sm-12 col-lg-4" style={{margin:"0 auto"}}> 
                        <Label for="Select">Student *</Label> 
                        <FormGroup>   
                           <Label for="Select">Student *</Label>                                           
                           <Selectsearch id="student" name="student" placeholder="Select..." options={allstudent} rules={{ required: 'Please select an student'}} value={allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required/>
                        </FormGroup>
                  </div>
               }                          
               {this.state.listdiv && 
                  <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Test</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>
               }
               {this.state.adddiv && 
                  <AddItem onClick={this.onBackSection} data={this.state}/>                
               }

               {this.state.editdiv && 
                  <EditItem onClick={this.onBackSection} data={this.state}/>              
               }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'on course score'}
            />
                  
          </div>
       )
    }
 }

const mapStateToProps = ({ mostlyused, ocscoring }) => {
   const { studentlists } = mostlyused;
	const { ocscoringlist, loading } = ocscoring;
	return { studentlists, ocscoringlist, loading };
}

export default connect(mapStateToProps, {

   deleteOCScoring,
   studentOCScoring,
   fetchOCScoring,
   allStudents
})(captoreport); 